// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"245f9022","345":"eb4181d7"}[chunkId] + ".chunk.js";
};